import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToActive = (
    active$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    active$
        .subscribe(() => setTimeout(() => frameStore.actions.activateControls()));

export default subscribeToActive;